import {
    CREATE_KNITTING_DC_FAILURE,
    CREATE_KNITTING_DC_REQUEST,
    CREATE_KNITTING_DC_SUCCESS,
    CREATE_USER_FORM_KNITTING_DC,
    FETCH_SINGLE_KNITTING_DC_FAILURE,
    FETCH_SINGLE_KNITTING_DC_REQUEST,
    FETCH_SINGLE_KNITTING_DC_SUCCESS,
    FETCH_KNITTING_DC_FAILURE,
    FETCH_KNITTING_DC_REQUEST,
    FETCH_KNITTING_DC_SUCCESS,
    NAVIGATE_KNITTING_DC_DETAILS,
    NAVIGATE_KNITTING_DC,
    KNITTING_DC_USERFORM_RESET,
    UPDATE_KNITTING_DC_FAILURE,
    UPDATE_KNITTING_DC_REQUEST,
    UPDATE_KNITTING_DC_SUCCESS,
    DELETE_KNITTING_DC_REQUEST,
    DELETE_KNITTING_DC_SUCCESS,
    DELETE_KNITTING_DC_FAILURE,
    KNITTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB,
    KNITTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE,
    FETCH_YARN_PO_IN_KNITTING_DC_REQUEST,
    FETCH_YARN_PO_IN_KNITTING_DC_SUCCESS,
    FETCH_YARN_PO_IN_KNITTING_DC_FAILURE,
    FETCH_KNITTING_DC_INVOICE_REQUEST,
    FETCH_KNITTING_DC_INVOICE_SUCCESS,
    FETCH_KNITTING_DC_INVOICE_FAILURE,
    FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_REQUEST,
    FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_SUCCESS,
    FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_FAILURE,
    RESET_KNITTING_DC_INVOICE,
    CHECK_ALL_UPDATE_FALIURE_KNITTING,
    CHECK_ALL_UPDATE_REQUEST_KNITTING,
    CLOSE_BTN_POST_REQUEST_KNITTING,
    CLOSE_BTN_POST_FALIURE_KNITTING,
    HEADER_SEARCH_CALL_ONLOAD,
    NAVIGATE_KNITTING_DC_PRINT,
    FETCH_KNITTING_DC_DETAILS_PRINT_SECOND_GRID_STYLE_SUCCESS,
    FETCH_KNITTING_DC_DETAILS_PRINT_SECOND_GRID_STYLE_REQUEST,
    FETCH_KNITTING_DC_DETAILS_PRINT_SECOND_GRID_STYLE_FAILURE
} from './knittingDC.actionsType';

export const KNITTING_DC = 'knittingDC';

let initialState = {
    loading: false,
    knittingDC: [],
    yarnPOInKnittingDC: [],
    knittingDCInvoiceV2: [],
    supplierListBasedOnProgram: [],
    rateKg: '',
    userform: {
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldIsInHouseDelivery: false,
        fldIsInHouseProduction: false,
        fldItemsTotalValue: 0,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldRoundoff: 0,
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date(),
        unitId: 1
    },
    selectedTeam: {},
    detailsId: '',
    activeKey: 1,
    isKnittingDC: false,
    knittingDCSelectedValue: null,
    errorMessage: '',
    iperrorMessage: '',
    headerSearchCall: true
};

export let knittingDCReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    if (type === 'CREATE_KNITTING_DC_SUCCESS') {
        localStorage.setItem('DetailStyleIdKni', JSON.stringify(updatePayload));
    }
    switch (type) {
        case FETCH_KNITTING_DC_REQUEST:
        case FETCH_YARN_PO_IN_KNITTING_DC_REQUEST:
        case CREATE_KNITTING_DC_REQUEST:
        case FETCH_KNITTING_DC_INVOICE_REQUEST:
        case FETCH_SINGLE_KNITTING_DC_REQUEST:
        case UPDATE_KNITTING_DC_REQUEST:
        case DELETE_KNITTING_DC_REQUEST:
        case CHECK_ALL_UPDATE_REQUEST_KNITTING:
        case CLOSE_BTN_POST_REQUEST_KNITTING:
        case FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_REQUEST:
        case FETCH_KNITTING_DC_DETAILS_PRINT_SECOND_GRID_STYLE_REQUEST:
            return {
                ...state,
                // loading: true
            };
        case FETCH_KNITTING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                knittingDC: updatePayload
            };

        case HEADER_SEARCH_CALL_ONLOAD:
            return {
                ...state,
                loading: false,
                headerSearchCall: payload
            }

        case FETCH_KNITTING_DC_DETAILS_PRINT_SECOND_GRID_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                knittingDCInvoiceSecondV2: updatePayload
            }

        case FETCH_KNITTING_DC_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                knittingDCInvoiceV2: updatePayload
            };
        case FETCH_YARN_PO_IN_KNITTING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnPOInKnittingDC: updatePayload?.PONO
            };
        case FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: { ...state.userform, fldRate: updatePayload }
            };
        case CREATE_KNITTING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: updatePayload
            };
        case FETCH_SINGLE_KNITTING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedTeam: updatePayload,
                userform: {
                    ...updatePayload,

                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                }
            };
        case UPDATE_KNITTING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId

                },
                detailsId: ''
            };
        case DELETE_KNITTING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                detailsId: ''
            };
        case FETCH_KNITTING_DC_FAILURE:
        case FETCH_YARN_PO_IN_KNITTING_DC_FAILURE:
        case FETCH_SINGLE_KNITTING_DC_FAILURE:
        case CREATE_KNITTING_DC_FAILURE:
        case UPDATE_KNITTING_DC_FAILURE:
        case DELETE_KNITTING_DC_FAILURE:
        case FETCH_KNITTING_DC_INVOICE_FAILURE:
        case CHECK_ALL_UPDATE_FALIURE_KNITTING:
        case CLOSE_BTN_POST_FALIURE_KNITTING:
        case FETCH_KNITTING_DC_DETAILS_PRINT_SECOND_GRID_STYLE_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_KNITTING_DC:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case KNITTING_DC_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId

                },
                detailsId: '',
                activeKey: 1
            };
        case NAVIGATE_KNITTING_DC_DETAILS:
            return {
                ...state,
                isKnittingDC: true,
                knittingDCSelectedValue: updatePayload.knittingDCSelectedValue
            };
        case NAVIGATE_KNITTING_DC:
            return {
                ...state,
                isKnittingDC: false
            };
        case NAVIGATE_KNITTING_DC_PRINT:
            return {
                ...state,
                isKnittingDC: false,
                loading: false,
                knittingDCSelectedValue: updatePayload.knittingDCSelectedValue
            }
        case RESET_KNITTING_DC_INVOICE:
            return {
                ...state,
                knittingDCInvoiceV2: []
            };
        case KNITTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId

                },
                activeKey: 2
            };
        case KNITTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId

                },
                activeKey: 1
            };
        default:
            return state;
    }
};
